// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"src-components-UI-Links-ExternalLink-styles-style-module__externalLink--1nmPI"};